import api from "./axios";
import {
  THIS_APP,
  type AuthResponse,
  type ProfileResponse,
  type SignupResponse,
  type ResendVerificationResponse,
} from "types";

/**
 * Role-aware sign-in.
 *
 * Uses /auth/app-login rather than /auth/login: the plain endpoint is shared
 * with ungated tools and lets every user in whatever roles they hold, so the
 * check has to be asked for. A 403 here means the credentials were right but
 * the account holds no role that opens this tool.
 */
export const login = (email: string, password: string) =>
  api.post<AuthResponse>("/auth/app-login", {
    email,
    password,
    app: THIS_APP,
  });

export const signup = (data: {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
}) => api.post<SignupResponse>("/auth/signup", data);

export const verifyEmail = (email: string, code: string) =>
  api.post<AuthResponse>("/auth/verify-email", { email, code });

export const resendVerification = (email: string) =>
  api.post<ResendVerificationResponse>("/auth/resend-verification", { email });

export const getProfile = () => api.get<ProfileResponse>("/auth/profile");

export const loginWithToken = (token: string) =>
  api.post<AuthResponse>("/auth/login-with-token", { token });

export interface MessageResponse {
  success: boolean;
  message: string;
}

export const forgotPassword = (email: string) =>
  api.post<MessageResponse>("/auth/forgot-password", { email });

export const resetPassword = (email: string, code: string, newPassword: string) =>
  api.post<MessageResponse>("/auth/reset-password", { email, code, newPassword });
